exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column {\n  display: inline-block;\n  background-color: white;\n  width: 240px;\n  margin-right: 20px;\n  padding: 30px;\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.1);\n  position: relative;\n  height: 100%; }\n  @media screen and (min-width: 768px) {\n    .column {\n      width: 300px; } }\n  .column__title {\n    font-size: 26px;\n    text-transform: uppercase;\n    text-align: center;\n    padding-bottom: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.5); }\n  .column__remove {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: inherit;\n    color: rgba(0, 0, 0, 0.5); }\n  .column__body {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Column/column.scss
// module id = 5365
// module chunks = 0